

















/* Created- 05 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ArticleImage, IArticle } from "../../../Models/ArticleModels/article";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { ParticaListContent, ParticaListLineContent } from "../../../Models/ParticaListModel";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";

@Component(
	{
		name: "ArticleImages",
		components: { ParticaCard }
	})
export default class ArticleImages extends Vue {
	@Prop() private value: IArticle; // your data        
	@Prop() private issueguid: string;
	private openPanel: number = -1;
	/*@Watch("openPanel")
	private openPanelChange() {
		this.$emit("image-panel-changed", this.openPanel);
	}*/
	private getImagePath(img: ArticleImage) {
		if (this.issueguid !== undefined) {
			return img.getPath(this.$store.state.config.thumburl, this.issueguid);
		} else {
			return this.value.getImageSrc(this.$store.state.config.thumburl, img.src, 300);
		}
	}
	private getImageList(): ParticaListContent {
		const data: ParticaListContent = new ParticaListContent();
		data.title = "Images";
		this.value.images.forEach(image => {
			const line: ParticaListLineContent = new ParticaListLineContent();
			line.title = image.caption;
			line.subtitle = image.contributor;
			line.image = image.getPath(this.$store.state.config.thumburl, this.issueguid);
			data.lines.push(line);
		});
		return data;
	}
	private changed() {
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}
}
